import React from 'react';
import { Alert, AlertDescription } from "../../ui/alert";
import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CostSummary = ({ totalCost, userPoints, hasEnoughPoints }) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center text-sm sm:text-base">
        <span>{t('parking.costSummary.totalCost')}:</span>
        <span className="font-medium">{totalCost} {t('parking.costSummary.points')}</span>
      </div>
      <div className="flex justify-between items-center text-sm sm:text-base">
        <span>{t('parking.costSummary.yourBalance')}:</span>
        <span className="font-medium">{userPoints || 0} {t('parking.costSummary.points')}</span>
      </div>
      {!hasEnoughPoints && (
        <Alert variant="destructive" className="text-xs sm:text-sm p-2 sm:p-4">
          <AlertCircle className="h-3 w-3 sm:h-4 sm:w-4 mr-2" />
          <AlertDescription>
            {t('parking.costSummary.insufficientPoints')}
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
};

export default CostSummary;